import React from 'react';
import PropTypes from 'prop-types';
import {Provider} from 'react-redux';
import {BrowserRouter as Router} from 'react-router-dom';
import createBrowserHistory from 'history/createBrowserHistory';

import App from '../../containers/App/App';
import DevTools from '../../components/Shared/DevTools';

const customHistory = createBrowserHistory();

const Root = ({store}) => (
  <Provider store={store}>
    <div>
      <Router history={customHistory}>
        <App />
      </Router>
      <DevTools />
    </div>
  </Provider>
);

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
};

export default Root;



// WEBPACK FOOTER //
// ./containers/Root/Root.dev.container.js